import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 20 Dec 2025 2:04 AM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.ncL39Joq4F_KvIrY7frOdTONTX5HdRut14iHP1nIWjvWLxDdBl2ThRA-mu3MvWPKdSXeJ54nwU9osvbSSQtXVXS1mdUA8T611CdkqIPIuc923b8gW8q-9ecAZyVrZRnz4uRdBKF5NnvSDrpswEwuy8dHysuJJ11hg_V7TeWd85eSNgMzi6BSqh9C18th31hChpX1J3Ma0ndQP3l0fGJIOEP0ytHC14TVTSVh9I4_Oegh3r36uOX89b0NdmAp8oUfE9Yw_eueAhibWXbFxJ90HwMVT4wdFHKwhjQocht9dBrDtSpxg5_XXRz0of7qJKG_icfErF_itwcusXlVw7et_TzWkX8B6omC6Q",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-12-27T01:04:44.306002Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2025-12-20T01:04:12+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.ncL39Joq4F_KvIrY7frOdTONTX5HdRut14iHP1nIWjvWLxDdBl2ThRA-mu3MvWPKdSXeJ54nwU9osvbSSQtXVXS1mdUA8T611CdkqIPIuc923b8gW8q-9ecAZyVrZRnz4uRdBKF5NnvSDrpswEwuy8dHysuJJ11hg_V7TeWd85eSNgMzi6BSqh9C18th31hChpX1J3Ma0ndQP3l0fGJIOEP0ytHC14TVTSVh9I4_Oegh3r36uOX89b0NdmAp8oUfE9Yw_eueAhibWXbFxJ90HwMVT4wdFHKwhjQocht9dBrDtSpxg5_XXRz0of7qJKG_icfErF_itwcusXlVw7et_TzWkX8B6omC6Q'

// {
//   "access_token": "v2.local.aSxevHYsRQktWyJYkowXl9bQTz8uizXvXUePmS1Yd__apelx-E6TR-t_cwunhtduHh8DBUk3bd-JqtdrvoEHunERaUoyUs5JgkqybYKT2Ly1CqhGBdT4nJCJvHADzl8lO3dZVSfFngvzcoad5K4bxbLkdwLnFNSvsY-e3AoUQfth9GDlkD1iBTuOTOnGF5SrlSeT731rz9ldJ6N4IWQYEVlU3Z0Sm3MYRGNVn4h5eqa1sFth26q4oUJLjJcueVrQFNHaOKgKHzvvadVfgDsIBhTiIyobRt5jfxM9zdVQ18AuQsw3Pkfy17FSyKy05fQlK84bL6XYIBBaQMZ9UVHmOF3jJpkz",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-12-27T01:05:50.702547Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2025-12-20T01:05:47+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.aSxevHYsRQktWyJYkowXl9bQTz8uizXvXUePmS1Yd__apelx-E6TR-t_cwunhtduHh8DBUk3bd-JqtdrvoEHunERaUoyUs5JgkqybYKT2Ly1CqhGBdT4nJCJvHADzl8lO3dZVSfFngvzcoad5K4bxbLkdwLnFNSvsY-e3AoUQfth9GDlkD1iBTuOTOnGF5SrlSeT731rz9ldJ6N4IWQYEVlU3Z0Sm3MYRGNVn4h5eqa1sFth26q4oUJLjJcueVrQFNHaOKgKHzvvadVfgDsIBhTiIyobRt5jfxM9zdVQ18AuQsw3Pkfy17FSyKy05fQlK84bL6XYIBBaQMZ9UVHmOF3jJpkz'

// {
//   "access_token": "v2.local.QQfhuiV5TkoCj8PuKeZwPQL4nzyRBeJxyMOiTcEukgqNTtEB1FyMvaIwvirCAoKPZw64qcItESQTdbcE7LTkbWJ9Et1IOUOuXpRsvHoBclGFKz4LvcDDgtQu6p3JaYiTLzhDNkD8avJDJsRF6kRYmIMhqz2FbPH9zVyHmm8uEQsNRvkfZzO--ldSuEMeZIWV-A_DLuIYZan1UcQaemH54hSaoZcPwjJ3h33jqhorFvISLXyKNFkeduAEdRVfDY2rjDzcK_otgO6_Xd6QI4ccB1r3XE5ae_yGnIc4VdXXlEJ5c_KrdJZ_DZJiCZEYveeivbbU6DjST2dSMVWFpTKpFxIGSW0",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-12-27T01:07:01.715251Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.QQfhuiV5TkoCj8PuKeZwPQL4nzyRBeJxyMOiTcEukgqNTtEB1FyMvaIwvirCAoKPZw64qcItESQTdbcE7LTkbWJ9Et1IOUOuXpRsvHoBclGFKz4LvcDDgtQu6p3JaYiTLzhDNkD8avJDJsRF6kRYmIMhqz2FbPH9zVyHmm8uEQsNRvkfZzO--ldSuEMeZIWV-A_DLuIYZan1UcQaemH54hSaoZcPwjJ3h33jqhorFvISLXyKNFkeduAEdRVfDY2rjDzcK_otgO6_Xd6QI4ccB1r3XE5ae_yGnIc4VdXXlEJ5c_KrdJZ_DZJiCZEYveeivbbU6DjST2dSMVWFpTKpFxIGSW0'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
